/**
 * This will watch a video item for viewport intersection
 * On intersection some elements will be added
 * @example ng-video-item=""
 */

const ngNativeView = ['$http', ($http) => {
    return {
        scope: { id: '=ngNativeView'},

        link: ( $scope, $item, $params ) => {
            let intersect = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.intersectionRatio > 0) {
                        intersect.unobserve(entry.target);
                        $http.get(window.variables.native.trackViewUrl, { params: { id: $scope.id } });
                    }
                });
            });
            intersect.observe($item[0]);
        }
    };
}];

export default ngNativeView;

